import { connect } from 'react-redux';
import { schema } from '../../../../../state/schema';
import { denormalize } from 'normalizr';
import {
  moduleAdminHidePreviewDetail,
  loadModuleAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';

import LearningAdminModuleModalPreview from '../components/LearningAdminModuleModalPreview';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const moduleId = state.learningsAdmin.get('moduleDetailModuleId');

  const learningModule = moduleId
    ? denormalize(
        state.entities.getIn(['learningModulesAdmin', moduleId]),
        schema.learningModuleAdmin,
        state.entities.toJS()
      )
    : null;

  return {
    isVisible: state.learningsAdmin.get('moduleDetailIsVisible'),
    moduleId: moduleId,
    learningModule: learningModule,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideDetail: () => {
      dispatch(moduleAdminHidePreviewDetail());
    },
    load: (partnership_id, id, cb) => {
      dispatch(loadModuleAdmin(partnership_id, id, cb));
    },
  };
};

const LearningAdminModuleModalPreviewContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleModalPreview);

export default LearningAdminModuleModalPreviewContainer;
